// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Chip from '@liquidweb-dev/undercurrent/Chip';
import LoaderCircleIcon from '@liquidweb-dev/undercurrent/icons/animated/LoaderCircle';
import CircleFilledIcon from '@liquidweb-dev/undercurrent/icons/custom/CircleFilled';
import CircleIcon from '@liquidweb-dev/undercurrent/icons/lucide/Circle';
import CornerLeftUpIcon from '@liquidweb-dev/undercurrent/icons/lucide/CornerLeftUp';
import FolderIcon from '@liquidweb-dev/undercurrent/icons/lucide/Folder';
import XIcon from '@liquidweb-dev/undercurrent/icons/lucide/X';
import Link from '@liquidweb-dev/undercurrent/Link';
import ApplicationIcon from 'components/standard/ApplicationIcon';
import DisplayTypeChip from 'components/standard/DisplayTypeChip';
import { managementMap } from 'components/standard/DrawerReimage/helpers';
import { Link as RouterLink } from 'react-router-dom';
import createServerStatus from 'utility/createServerStatus';

/**
 * @param {import('club-sauce/public/asset').LWApiPublicAssetStatusT} status
 * @param {import('modules/queries/asset/useDetails').AssetDetails['powerStatus']} [powerStatus]
 * @return {{ color: import('@liquidweb-dev/undercurrent/Chip').ChipProps['color'], label: string, icon?: import('@liquidweb-dev/undercurrent/Chip').ChipProps['icon'] }}
 * */
const getStatusProps = (status, powerStatus) => {
	const { level, label } = createServerStatus(status, powerStatus);

	switch (level) {
		case 'on':
			return {
				label,
				color: 'success',
				icon: <CircleFilledIcon />,
			};

		case 'settingUp':
			return {
				label,
				color: 'warning',
				icon: (
					<LoaderCircleIcon
						sx={({ size }) => ({ height: size.xS, width: size.xS })}
					/>
				),
			};

		case 'off':
			return {
				label,
				color: 'default',
				icon: <CircleIcon />,
			};

		case 'problem':
			return {
				label,
				color: 'error',
				icon: <XIcon />,
			};

		default:
			return { label, color: 'default' };
	}
};

/** @param {import('modules/queries/asset/useDetails').AssetDetails} props */
const AttributesContent = ({
	displayType,
	managementLevel,
	powerStatus,
	privateParent,
	project_name: projectName,
	status,
	templateApp,
}) => {
	const privateParentName = privateParent?.custom_name || privateParent?.domain;
	const privateParentPath = `/servers/${privateParent?.uniq_id}`;

	return (
		<>
			<Chip size="small" {...getStatusProps(status, powerStatus)} />
			{templateApp && (
				<Chip
					label={templateApp}
					size="small"
					icon={<ApplicationIcon application={templateApp} />}
				/>
			)}
			{displayType && <DisplayTypeChip displayType={displayType} />}
			{managementLevel && (
				<Chip
					label={managementMap[managementLevel]?.label || managementLevel}
					size="small"
				/>
			)}
			{projectName && (
				<Chip label={projectName} size="small" icon={<FolderIcon />} />
			)}
			{privateParentName && (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: 50,
						marginLeft: 200,
					}}
				>
					<CornerLeftUpIcon />

					<Link
						component={RouterLink}
						to={privateParentPath}
						variant="label-lg"
					>
						{privateParentName}
					</Link>
				</Box>
			)}
		</>
	);
};

export default AttributesContent;
